<template>
  <div>
    <v-dialog
      v-model="dialog"
      width="500"
      overlay-color="rgba(39, 50, 64)"
      overlay-opacity="0.6"
      :fullscreen="$vuetify.breakpoint.xs ? true : false"
    >
      <process
        ref="process"
        :invoice-id="invoiceId"
      />
     
      <v-card>
        <v-card-title class="header">
          {{ $t('globals.depositButton') }}
        </v-card-title>
        <v-card-text class="mt-4">
          <div class="mt-6 mb-8">
            {{ $t('globals.depositDesc') }}
          </div>
          <v-text-field
            v-model.trim="amount"
            class="mt-3"
            name="amount"
            maxlength="12"
            :label="$t('withdrawals.amount')"
            :error-messages="AmountErrors"
            @input="$v.amount.$touch()"
            @blur="$v.amount.$touch()"
            @keypress="onlyForCurrency($event, amount)"
          >
            <template v-slot:append>
              <small
                class="text-no-wrap text-right"
              >
                {{ $t('globals.reqMax') }}:
                <b 
                  :class="'text-positive'"
                  style="cursor: pointer;"
                  @click="amount = 2500"
                >2500 USDT</b>
                <br>
                <small>{{ $t('withdrawals.reqMin') }}: 10 USDT</small>
              </small>
            </template>
          </v-text-field>
        </v-card-text>
        <v-divider />

        <v-card-actions>
          <v-spacer />
          <v-btn
            class="primary"
            @click="activate"
          >
            {{ $t('globals.depositButton') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>

import DEPOSIT_FUNDS_MUTATION from "@/graphql/mutations/DepositFunds.gql";
import Process from '@/views/Gateways/Process.vue'

import { validationMixin } from "vuelidate";
import {
  required,
  minValue,
  maxValue
} from "vuelidate/lib/validators";

export default {
  name: 'DepositFunds',
   components: {
    Process
  },
  mixins: [validationMixin],
  props: {
    type: {
      type: String,
      default: 'activate'
    },
  },
  data: () => ({
    dialog: false,
    invoiceId: null,
    amount: 0
  }),
  validations() {
    return {
      amount: {
        required,
        minValue: minValue(10),
        maxValue: maxValue(2500)
      }
    };
  },
  computed: {
    AmountErrors() {
      const errors = [];
      if (!this.$v.amount.$dirty) return errors;
      !this.$v.amount.required && errors.push(this.$t("aff.reqField"));
      !this.$v.amount.minValue &&
        errors.push(
          this.$t("withdrawals.reqMinAmount") +
            ": 10 USDT"
        );
      !this.$v.amount.maxValue &&
        errors.push(
          this.$t("withdrawals.reqMaxAmount") +
            ": 2500 USDT"
        );
      return errors;
    }
  },
  methods: {
    open() {
      this.dialog = true
    },
    close() {
      this.dialog = false
    },
    activate() {
      this.loading = true;
      this.$apollo
        .mutate({
          mutation: DEPOSIT_FUNDS_MUTATION,
          variables: {
            amount: parseFloat(this.amount),
          }
        })
        .then(data => {
          this.invoiceId = data.data.depositFunds.id
          this.close()
          this.$refs.process.open()
        })
        .catch(error => {
          this.errorHandler(error);
          this.loading = false;
        });
    }
  }
}
</script>

